import React from 'react';
import styled from 'styled-components';

const StyledHeaderLink = styled.a`
  text-decoration: initial;
  color: initial;
`;

const StyledHeader = styled.header`
  position: fixed;
  width: 100%;
  height: 64px;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid black;
  color: white;
  background-color: black;
`;

const StyledHeaderTitle = styled.h1`
  font-size: 20px;
  font-family: Helvetica;
  font-weight: normal;
  text-transform: uppercase;
`;

const Header = () => (
  <StyledHeaderLink href="/">
    <StyledHeader>
      <StyledHeaderTitle>The People's store</StyledHeaderTitle>
    </StyledHeader>
  </StyledHeaderLink>
);

const Main = styled.main`
  margin: 110px auto 64px;
  border-top: 1px solid black;
  border-bottom: 1px solid black;
`;

export { Header, Main };
